import classNames from 'classnames';

export const prefix = (testId: string) => `jg-test__chrome__${testId}`;

export default (...testIds: string[]): string =>
  __TEST__ ? classNames(testIds.map(prefix)) : '';
